"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _InlineWysiwyg = _interopRequireDefault(require("./InlineWysiwyg"));
var _DragAndDrop = require("./DragAndDrop");
var _cccisdLaravelResources = require("cccisd-laravel-resources");
var _SectionTitle = _interopRequireDefault(require("./SectionTitle"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var Presenters = function Presenters(_ref) {
  var formProps = _ref.formProps;
  var setPresenters = function setPresenters(presenterList) {
    // Need to deep copy to force formProps.dirty and a re-render
    formProps.setValues(_objectSpread(_objectSpread({}, formProps.values), {}, {
      courseDescription: _objectSpread(_objectSpread({}, formProps.values.courseDescription), {}, {
        presenters: _objectSpread(_objectSpread({}, formProps.values.courseDescription.presenters), {}, {
          sections: presenterList
        })
      })
    }));
  };
  var onDragEnd = function onDragEnd(result) {
    if (!result.destination || !result.source) {
      return;
    }
    var fromIndex = result.source.index;
    var toIndex = result.destination.index;
    var presenters = (0, _DragAndDrop.dndSwap)(formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    }), fromIndex, toIndex);
    setPresenters(presenters);
  };
  var onClickAdd = function onClickAdd() {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    var highestKey = 0;
    presenters.forEach(function (presenter) {
      if (presenter.key > highestKey) {
        highestKey = presenter.key;
      }
    });
    presenters.push({
      name: '',
      title: '',
      position: '',
      bio: '',
      image: '',
      key: highestKey + 1
    });
    setPresenters(presenters);
  };
  var onClickDelete = function onClickDelete(key) {
    var presenters = formProps.values.courseDescription.presenters.sections.filter(function (presenter) {
      return presenter.key !== key;
    });
    setPresenters(presenters);
  };
  var onSelectImage = function onSelectImage(imageObj, index) {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    presenters[index].image = imageObj;
    setPresenters(presenters);
  };
  var onDeleteImage = function onDeleteImage(index) {
    var presenters = formProps.values.courseDescription.presenters.sections.map(function (presenter) {
      return _objectSpread({}, presenter);
    });
    presenters[index].image = '';
    setPresenters(presenters);
  };
  var validateImageDimensions = function validateImageDimensions(index) {
    var presenter = formProps.values.courseDescription.presenters.sections[index];
    if (!presenter || !presenter.image || !presenter.image.metadata) {
      return;
    }
    // Image will be a centered, cover background with
    // width of 150px and height of 180px (), so this
    // checks that it will not be cropped undexpectedly
    var _presenter$image$meta = presenter.image.metadata,
      width = _presenter$image$meta.width,
      height = _presenter$image$meta.height;
    var ratio = width / height;
    return ratio < 0.9 && ratio > 0.75;
  };
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    className: _style["default"].fieldsetHeading
  }, "Presenters"), /*#__PURE__*/_react["default"].createElement(_SectionTitle["default"], {
    name: "presenters",
    placeholder: "Presenters"
  }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "presenters"
  }, function (dropProvided, dropSnapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, dropProvided.droppableProps, {
      ref: dropProvided.innerRef,
      className: "form-group"
    }), dropProvided.placeholder, formProps.values.courseDescription.presenters.sections.map(function (presenter, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: "presenter-".concat(presenter.key),
        index: index,
        key: "presenter-".concat(presenter.key)
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps, dragProvided.dragHandleProps, {
          className: _style["default"].dragContainer
        }), dragProvided.placeholder, /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndArrows, null), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].dragAndDropContent
        }, /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].name"),
          label: "Name"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].title"),
          label: "Title"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].position"),
          label: "Position"
        }), /*#__PURE__*/_react["default"].createElement(_InlineWysiwyg["default"], {
          name: "courseDescription.presenters.sections[".concat(index, "].bio"),
          label: "Bio"
        }), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].presenterImage
        }, presenter.image && /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            backgroundImage: "url(\"".concat(presenter.image.url, "\")")
          },
          className: _style["default"].bgImage
        }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelResources.ImagePicker, {
          onChange: function onChange(img) {
            return onSelectImage(img, index);
          },
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: "btn btn-default"
          }, presenter.image ? 'Change' : 'Add', " image")
        }), presenter.image && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          onClick: function onClick() {
            return onDeleteImage(index);
          },
          className: "btn btn-default"
        }, "Remove image"), presenter.image && !validateImageDimensions(index) && /*#__PURE__*/_react["default"].createElement("p", {
          className: "bg-warning"
        }, /*#__PURE__*/_react["default"].createElement("small", null, "Note: Ideal image dimensions are 300px (w) by 360px (h). Please verify thumbnail."))))), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndDeleteButton, {
          onClick: function onClick() {
            return onClickDelete(presenter.key);
          }
        }));
      });
    }), /*#__PURE__*/_react["default"].createElement(_DragAndDrop.DndAddButton, {
      onClick: onClickAdd
    }));
  })));
};
var _default = Presenters;
exports["default"] = _default;